<template>
  <footer class="footer">
    <b-container>
      <b-row>
        <b-col>
          <span>© 2018. Design and develope by Ronnel Sanchez</span>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue